import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import OnlyHeader from "components/Headers/OnlyHeader";
import KnowledgeArticleForm from "./KnowledgeArticleForm";
import { createKnowledgeArticle } from "store/actions/chatbotKnowledgeAction";

const AddKnowledgeArticle = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { saveArticleLoader } = useSelector((state) => state.chatbotKnowledge);

  const handleSubmit = (formData) => {
    dispatch(
      createKnowledgeArticle(formData, () => {
        history.push("/admin/chatbot-knowledge");
      })
    );
  };

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <KnowledgeArticleForm
              onSubmit={handleSubmit}
              isLoading={saveArticleLoader}
              isEdit={false}
              initialValues={{
                title: "",
                category: "faq",
                content: "",
                keywords: [],
                status: "published",
              }}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddKnowledgeArticle;
